var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            title: _vm.config.title,
            visible: _vm.dialogVisible,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt15",
              attrs: {
                "label-width": _vm.labelWidth + "px",
                model: _vm.rules,
                rules: _vm.rule,
              },
            },
            [
              _c(
                "div",
                { staticClass: "alert" },
                [
                  _c("el-alert", {
                    staticClass: "cr-alert",
                    attrs: {
                      description:
                        this.config.type == "edit"
                          ? "保存后，收支记账与对应合同账目记录也会同步修改！"
                          : "审核通过后，系统自动生成收支记账流水信息！",
                      "show-icon": "",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.config.type !== "edit"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "bill_cate_id" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("账目分类："),
                      ]),
                      _vm._v(" "),
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.statusOption,
                          props: {
                            checkStrictly: true,
                            label: "name",
                            value: "id",
                            emitPath: false,
                          },
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.rules.bill_cate_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "bill_cate_id", $$v)
                          },
                          expression: "rules.bill_cate_id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.types !== 0
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "cate_id" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("续费类型： "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("customer.placeholder31"),
                            size: "small",
                          },
                          model: {
                            value: _vm.rules.cate_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.rules, "cate_id", $$v)
                            },
                            expression: "rules.cate_id",
                          },
                        },
                        _vm._l(_vm.sourceOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.value.title, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "amount" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.title01) + "："),
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    attrs: {
                      controls: false,
                      max: 999999.99,
                      placeholder: _vm.placeholder01,
                      size: "small",
                    },
                    model: {
                      value: _vm.rules.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.rules, "amount", $$v)
                      },
                      expression: "rules.amount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.types == 1
                ? _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("续费结束日期："),
                      ]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options":
                            _vm.config.type > 2 ? _vm.expireTimeOption : "",
                          type: "date",
                          placeholder: "请选择续费结束日期",
                          size: "small",
                        },
                        model: {
                          value: _vm.rules.end_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "end_date", $$v)
                          },
                          expression: "rules.end_date",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.config.type !== 3
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "type_id" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("支付方式："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择支付方式",
                            size: "small",
                          },
                          model: {
                            value: _vm.rules.type_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.rules, "type_id", $$v)
                            },
                            expression: "rules.type_id",
                          },
                        },
                        _vm._l(_vm.paymentOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.config.type !== 3
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "dateTime" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("付款时间："),
                      ]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        attrs: {
                          format: "yyyy/MM/dd HH:mm:ss",
                          "picker-options": "expireTimeOption",
                          placeholder: "请选择付款时间",
                          size: "small",
                          type: "datetime",
                        },
                        model: {
                          value: _vm.rules.dateTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "dateTime", $$v)
                          },
                          expression: "rules.dateTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.config.type !== 3
                ? _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("付款凭证："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "avatar" },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo mr10",
                            attrs: {
                              headers: _vm.myHeaders,
                              "http-request": _vm.uploadServerLog,
                              "show-file-list": false,
                              action: "##",
                            },
                          },
                          [
                            _vm.imageUrl
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: { src: _vm.imageUrl },
                                })
                              : _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon",
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "clew" }, [
                          _vm._v("\n            支持jpg、jpeg、png"),
                          _c("br"),
                          _vm._v("\n            建议734*1034 "),
                          _c("br"),
                          _vm._v("大小不超过2M\n          "),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "remarks" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(" 备注"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      maxlength: "50",
                      "show-word-limit": "",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.rules.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.rules, "remarks", $$v)
                      },
                      expression: "rules.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }